import P from 'prop-types';

export const OffCanvas = ({ data, children, handleClose }) => {
  const { key, title } = data;

  const handleClickClose = () => {
    return handleClose ? handleClose() : 0;
  };

  return (
    <div
      className="offcanvas offcanvas-end"
      data-bs-backdrop="static"
      tabIndex="-1"
      id={'offcanvas-' + key}
      aria-labelledby="staticBackdropLabel"
      style={{ width: '750px' }}
      onKeyDown={(e) => {
        if (e.code === 'Escape') handleClickClose();
      }}
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="staticBackdropLabel">
          {title}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={handleClickClose}
        ></button>
      </div>
      <div className="offcanvas-body">{children}</div>
    </div>
  );
};

OffCanvas.propTypes = {
  data: P.shape({
    key: P.string,
    title: P.string,
  }),
  children: P.node,
  handleClose: P.func,
};
